/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceStreamZoneEarnItem
 */
export interface SurfaceStreamZoneEarnItem {
    /**
     * FontAwesome icon name (e.g. "tv", "star")
     * @type {string}
     * @memberof SurfaceStreamZoneEarnItem
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStreamZoneEarnItem
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceStreamZoneEarnItem
     */
    points: number;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceStreamZoneEarnItem
     */
    active?: boolean;
}

/**
 * Check if a given object implements the SurfaceStreamZoneEarnItem interface.
 */
export function instanceOfSurfaceStreamZoneEarnItem(value: object): value is SurfaceStreamZoneEarnItem {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    return true;
}

export function SurfaceStreamZoneEarnItemFromJSON(json: any): SurfaceStreamZoneEarnItem {
    return SurfaceStreamZoneEarnItemFromJSONTyped(json, false);
}

export function SurfaceStreamZoneEarnItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceStreamZoneEarnItem {
    if (json == null) {
        return json;
    }
    return {
        
        'icon': json['icon'] == null ? undefined : json['icon'],
        'label': json['label'],
        'points': json['points'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function SurfaceStreamZoneEarnItemToJSON(json: any): SurfaceStreamZoneEarnItem {
    return SurfaceStreamZoneEarnItemToJSONTyped(json, false);
}

export function SurfaceStreamZoneEarnItemToJSONTyped(value?: SurfaceStreamZoneEarnItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'icon': value['icon'],
        'label': value['label'],
        'points': value['points'],
        'active': value['active'],
    };
}

